import { Form, Image } from 'antd';
import { Flag } from 'assets/images';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { isPhoneNumber } from 'tools/string';
import { CInput, CInputProps } from './c-input';

const StyleInput = styled.div`
  width: 40px;
`;

export interface CInputPhoneNumberProps extends CInputProps {
  value?: any;
  onChange?: any;
  name: string;
  label?: string;
  required?: boolean;
}

export const CInputPhoneNumber: React.FC<CInputPhoneNumberProps> = ({ name, label, required = true, ...props }) => {
  const { t } = useTranslation();

  return (
    <Form.Item
      name={name}
      label={label ? label : t('phone-number')}
      rules={[
        { required: required },
        {
          message: t('phone-number', { ns: 'form' }),
          validator: (rule, value) => {
            if (value) {
              const phone = isPhoneNumber(value, 'TH');
              if (value.length > 10 || !phone) {
                return Promise.reject(new Error(t('phone-number', { ns: 'form' })));
              } else if (value.length === 10) {
                return Promise.resolve();
              }
            }
            return required ? Promise.reject() : Promise.resolve();
          },
        },
      ]}
    >
      <CInput
        {...props}
        phoneNumber
        placeholder={label ? label : t('phone-number')}
        addonBefore={
          <StyleInput className="center !bg-[#af0505]">
            <Image src={Flag} height={15} preview={false} />
          </StyleInput>
        }
      />
    </Form.Item>
  );
};
